import type { ReactNode } from 'react';

/** Etiqueta + control + error de validación (mismo estilo en todos los formularios del panel). */
export function Campo({
  etiqueta,
  error,
  ayuda,
  children,
}: {
  etiqueta: string;
  error?: string | undefined;
  ayuda?: string;
  children: ReactNode;
}) {
  return (
    <label className="block">
      <span className="mb-1.5 block text-sm font-bold text-texto-2">{etiqueta}</span>
      {children}
      {ayuda && !error && <span className="mt-1 block text-xs text-texto-3">{ayuda}</span>}
      {error && (
        <span role="alert" className="mt-1 block text-xs font-semibold text-rojo-texto">
          {error}
        </span>
      )}
    </label>
  );
}
